import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AutocompleteResponse, DetailResponse } from "@core/entities";
import { environment } from "@environments/environment";
import { Observable } from "rxjs";

@Injectable()
export class LocationService {
  constructor(private http: HttpClient) {}

  public getPlaceDetails(placeId: string, retailerId: number): Observable<DetailResponse> {
    return this.http.get<DetailResponse>(
      `${environment.gateway.base_url}${environment.gateway.location_gateway_prefix}place-details?placeid=${placeId}&source=locationservices&retailer-id=${retailerId}`,
      { headers: { "retailer-id": retailerId + "" } }
    );
  }

  /**
   * Coordinates -> address through the location gateway (address-lookup `reverse-geocode`). Per the COR Address Lookup
   * guide the provider is chosen with `client=locationservices` (autocomplete and place details use `source`). The
   * response has the same shape as place details.
   */
  public reverseGeocode(lat: number, lng: number, retailerId: number): Observable<DetailResponse> {
    return this.http.get<DetailResponse>(
      `${environment.gateway.base_url}${environment.gateway.location_gateway_prefix}reverse-geocode?lat=${lat}&lng=${lng}&client=locationservices`,
      { headers: { "retailer-id": retailerId + "" } }
    );
  }

  public getAutocompleteSuggestions(input: string, lat: number, lng: number, retailerId: number): Observable<AutocompleteResponse[]> {
    return this.http.get<AutocompleteResponse[]>(
      `${environment.gateway.base_url}${
        environment.gateway.location_gateway_prefix
      }autocomplete?lat=${lat}&lng=${lng}&text=${encodeURIComponent(input)}&source=locationservices`,
      {
        headers: { "retailer-id": retailerId + "" },
      }
    );
  }
}
